import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M5.91,9,1.85,16l4.06,7H14l3.69-6.39h4V21.4H23V16.64H25.2c0,.61,0,1.56.06,3.06l1.3,0c0-1.12-.06-2.34-.06-3h2.25v5.17h1.3V15.34H17.7L14,9Zm7.36,1.3L16.58,16l-3.31,5.73H6.66L3.35,16l3.31-5.73Z' }),
  React.createElement('path', { d: 'M10,19.49A3.49,3.49,0,1,0,6.48,16,3.49,3.49,0,0,0,10,19.49Zm0-5.67A2.18,2.18,0,1,1,7.78,16,2.18,2.18,0,0,1,10,13.82Z' }),
  React.createElement('g', { id: 'Artboard-32' })
));